(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-footer"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() {
      document.querySelectorAll('.ss-footer details[data-ss-footer-acc]').forEach(function (d) {
        var collapse = d.closest('.ss-footer--collapse');
        d.open = !(collapse && mq.matches);
      });
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.ss-footer details[data-ss-footer-acc] > summary');
      if (!summary) return;
      var collapse = summary.closest('.ss-footer--collapse');
      if (!(collapse && mq.matches)) e.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-ss-header]');
    if (!header) return;
    var root = document.documentElement;
    var hide = header.dataset.hideOnScroll === 'true';
    var lastY = window.scrollY;
    var ticking = false;
    function overlap() {
      if (header.classList.contains('ss-header--transparent')) header.style.marginBottom = -header.offsetHeight + 'px';
    }
    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      if (hide) {
        var open = header.querySelector('details[open]');
        if (!open && y > lastY + 6 && y > header.offsetHeight * 2) root.classList.add('ss-hdr-hidden');
        else if (y < lastY - 6 || y <= header.offsetHeight) root.classList.remove('ss-hdr-hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    window.addEventListener('resize', overlap);
    overlap();
    onScroll();
    header.addEventListener('mouseenter', function () { root.classList.remove('ss-hdr-hidden'); });
    var search = header.querySelector('.ss-header__search');
    if (search) {
      search.addEventListener('toggle', function () {
        if (search.open) { var i = search.querySelector('input[type="search"]'); if (i) i.focus(); }
      });
      document.addEventListener('click', function (e) { if (search.open && !search.contains(e.target)) search.open = false; });
      search.addEventListener('keydown', function (e) { if (e.key === 'Escape') search.open = false; });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-main-product"]) return;
  try {
    
  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }
    function initCountdowns(root) {
      (root || document).querySelectorAll('[data-ss-countdown]').forEach(function (el) {
        if (el.dataset.ssCdReady) return;
        el.dataset.ssCdReady = '1';
        var end = new Date(String(el.dataset.ssCountdown).replace(' ', 'T')).getTime();
        if (isNaN(end)) { el.hidden = true; return; }
        function tick() {
          var left = Math.max(0, end - Date.now());
          if (left === 0 && el.dataset.hide === 'true') { el.hidden = true; return; }
          var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, sec = Math.floor(left / 1e3) % 60;
          el.querySelector('[data-cd="d"]').textContent = pad(d);
          el.querySelector('[data-cd="h"]').textContent = pad(h);
          el.querySelector('[data-cd="m"]').textContent = pad(m);
          el.querySelector('[data-cd="s"]').textContent = pad(sec);
          if (left > 0) setTimeout(tick, 1000);
        }
        tick();
      });
    }
    function initShare(root) {
      (root || document).querySelectorAll('[data-ss-share]').forEach(function (btn) {
        if (btn.dataset.ssShareReady) return;
        btn.dataset.ssShareReady = '1';
        btn.addEventListener('click', function () {
          var url = btn.dataset.url;
          if (navigator.share) { navigator.share({ title: btn.dataset.title, url: url }).catch(function () {}); return; }
          var label = btn.querySelector('span');
          var old = label.textContent;
          var done = function () { label.textContent = btn.dataset.copied || 'Copied'; setTimeout(function () { label.textContent = old; }, 1800); };
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
        });
      });
    }
    initCountdowns();
    initShare();
    document.addEventListener('shopify:section:load', function (e) { initCountdowns(e.target); initShare(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(root) {
      (root || document).querySelectorAll('[data-ss-rv-toggle]').forEach(function (btn) {
        if (btn.dataset.ssRvReady) return;
        btn.dataset.ssRvReady = '1';
        var panel = document.getElementById(btn.dataset.ssRvToggle);
        if (!panel) return;
        if (/[?&](review=thanks|contact_posted=true)/.test(window.location.search)) {
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
        btn.addEventListener('click', function () {
          panel.hidden = !panel.hidden;
          btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
          if (!panel.hidden) {
            var first = panel.querySelector('input:not([type="hidden"]):not([tabindex="-1"]), textarea');
            panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
          }
        });
      });
    }
    bind();
    document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
